module.exports = __webpack_public_path__ + "static/img/people3.57d0ce44.png";